import axios from '../axios.js'

export const listNotices = async () => {
  const { data } = await axios.get('/users/v2/notices')
  return data || []
}
